<template>
  <div class="container">
    <div class="btn-wrapper">
      <el-popover
        ref="popover1"
        placement="bottom-start"
        width="300"
        trigger="click"
      >
        <div>
          <classDishWrapper
            v-for="dish in selectedRows"
            :image="dish"
            :key="dish.class_id"
            style="
            display:inline-block; width:50px; height: 50px;float: left"
          >
          </classDishWrapper>
        </div>
        <!--<el-tag type="success">已选择</el-tag>-->
        <el-badge
          class="mark"
          :value="selectedRows.length || 0"
          slot="reference"
        >
          <el-button type="success" size="mini">查看已选</el-button>
        </el-badge>
      </el-popover>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <el-button type="danger" @click="cancelAddClass" size="mini"
        >取消</el-button
      >
      <el-button type="primary" @click="confirmAddClass" size="mini"
        >确定</el-button
      >
    </div>
    <vvTable
      class="vv-table"
      :data="dishes"
      :config="tableConfig"
      :min-width="0"
      :height="400"
      :itemHeight="70"
    >
      <template slot-scope="scope" slot="dish_name_slot">{{
        !scope.row.dish_native_name ? `暂无名称` : scope.row.dish_native_name
      }}</template>
      <template slot-scope="scope" slot="dish_desc_slot">{{
        !scope.row.dish_desc ? `暂无描述` : scope.row.dish_desc
      }}</template>
      <template slot-scope="scope" slot="image_slot">
        <el-popover placement="top" width="150" trigger="click">
          <div class="image-wrapper">
            <img :src="scope.row.dish_image_url" width="150" alt />
          </div>
          <classDishWrapper
            :image="scope.row"
            class="class-dish-wrapper-1"
            slot="reference"
          ></classDishWrapper>
        </el-popover>
      </template>
      <template slot-scope="scope" slot="event_slot">
        <el-button
          type="text"
          class="danger-text"
          @click="cancelSelectRow(scope.row)"
          v-if="selectedClassId.indexOf(scope.row.class_id) !== -1"
          >取消选择
        </el-button>
        <el-button type="text" @click="selectRow(scope.row)"
          v-else
          >选择</el-button>
      </template>
    </vvTable>
  </div>
</template>
<script>
import {mapActions, mapGetters, mapMutations} from 'vuex';
import {apiAddClassDishToCanteen} from '@/api';

import classDishWrapper from '_c/classDishWrapper';
import vvTable from 'vue-virtual-table';

export default {
  name: "",
  components: {
    vvTable,
    classDishWrapper
  },
  data() {
    return {
      selectedRows: []
    };
  },
  props: {
    dishes: {
      type: Array
    }
  },
  mounted() {
  },
  methods: {
    ...mapMutations(["setSubTitle"]),
    ...mapActions([]),
    // showButton(row) {
    //   console.log(this.$_.find(this.selectRow, a => a.class_id === row.class_id));
    //   return !!this.$_.find(this.selectRow, a => a.class_id === row.class_id);
    // },
    cancelSelectRow(row) {
      let { class_id } = row;
      let idx = this.$_.findIndex(this.selectedRows, a => a.class_id === class_id);
      if (idx !== -1) {
        this.$set(row, "select", false);
        this.selectedRows.splice(idx, 1);
      } else {
        this.$message.error("此碗碟未选择, 无需删除");
      }
    },
    selectRow(row) {
      let { class_id } = row;
      let tar = this.$_.find(this.selectedRows, a => a.class_id === class_id);
      if (!tar) {
        this.$set(row, "select", true);
        this.selectedRows.push(row);
      } else {
        this.$message.error("此碗碟已经存在");
      }
    },
    async confirmAddClass() {
      // this.modelAddDialogShow = false;
      // let classIdWilAdd = this.selectedRows.map(row => row.class_id);
      this.selectedRows.forEach(async (_class, index) => {
        await apiAddClassDishToCanteen({
          class_id: _class.class_id,
          dish_name: _class.dish_native_name || "",
          apiKey: this.api_key,
          canteen_id: this.listQuery.canteen.canteen_id
        });
        if (index === this.selectedRows.length - 1) {
          this.$emit('confirmAddClass');
          this.selectedRows = [];
        }
      });
    },
    cancelAddClass() {
      this.$emit('cancelAddClass');
      this.selectedRows = [];
    }
  },
  computed: {
    ...mapGetters(['userinfo', 'listQuery']),
    apiKey () {
      return this.userinfo().api_key;
    },
    selectedClassId () {
      return this.selectedRows.map(a => a.class_id);
    },
    tableConfig() {
      return [
        { prop: "_action", name: "名称", actionName: "dish_name_slot" },
        { prop: "_action", name: "描述", actionName: "dish_desc_slot" },
        { prop: "_action", name: "标准例图", actionName: "image_slot" },
        { prop: "_action", name: "操作", actionName: "event_slot" }
      ];
    }
  },
  watch: {}
};
</script>
<style scoped lang="scss">
.container {
  position: relative;
  .class-dish-wrapper-1 {
    display: inline-block;
    width: 50px;
    height: 50px;
  }
  .btn-wrapper {
    position: absolute;
    top: -100px;
    right: 0;
    text-align: right;
  }
}
</style>
